import { GET_MACHINE_TYPES_LOADING, GET_MACHINE_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getMachineTypesSuccess = payload => {
    return ({
        type: GET_MACHINE_TYPES_SUCCESS,
        payload
    })
}

export const getMachineTypesAsync = payload => dispatch => {
    return client.service('machine-types').find()
		.then((response) => {
            dispatch(getMachineTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}